import { makeRequest } from "../utils/api";

export const getRosterCodes = () => {
  return makeRequest(`/codes/`, "GET");
};

export const createRosterCode = () => {
  return makeRequest(`/codes/`, "POST");
};

export const deleteRosterCode = ({ codeId }) => {
  return makeRequest(`/codes/${codeId}/`, "DELETE");
};
